$.TemplateMaster = {
    SearchProduct: (language) => {
        let list = $("#product-search-modal .list-group");
        list.empty();
        $("#product-search-modal #noRecordsFound")
            .removeClass("d-block")
            .addClass("d-none");

        let search = $("#product-search-modal input").val();
        let res = $.Backend.SearchProduct(search, language, false);
        res.then(function (response) {
            const data = response.data;
            if (data.products.length > 0) {
                for (let product of data.products)
                    list.append(
                        `<a href="${
                            product.page ?? "#"
                        }" class="list-group-item list-group-item-action">${
                            product.name
                        } (${product.partNumber})</a>`,
                    );
            } else {
                $("#product-search-modal #noRecordsFound")
                    .removeClass("d-none")
                    .addClass("d-block");
            }
        });
    },
    SetCookie: (name, value, ttl) => {
        let expires = "";
        if (ttl) {
            let date = new Date();
            date.setTime(date.getTime() + ttl * 1000);
            expires = `; expires=${date.toUTCString()}`;
        }
        document.cookie = `${name}=${value ?? ""}${expires}; path=/`;
    },
    GetCookie: (name) => {
        let nameEQ = name + "=";
        let ca = document.cookie.split(";");
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === " ") c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0)
                return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    Consent: (name, essential, functional, performance, targeting) => {
        if (name.trim() === "") return;
        $.TemplateMaster.SetCookie(
            name,
            JSON.stringify({ essential, functional, performance, targeting }),
            60 * 60 * 24 * 50,
        );
    },
    GetConsent: (name) => {
        const cookie = $.TemplateMaster.GetCookie(name);
        if (!cookie)
            return {
                essential: false,
                functional: false,
                performance: false,
                targeting: false,
            };
        return JSON.parse(cookie);
    },
    EditConsent: () => {
        if ($("#consentModal") && $("#consentDetailsModal")) {
            const m = new bootstrap.Modal($("#consentModal"));
            m.show();
        }
    },
};

$(document).ready(function () {
    $("#open-product-search-btn").click(function () {
        $("#product-search-modal input").val("");
        $("#product-search-modal .list-group").empty();
        $("#product-search-modal #noRecordsFound")
            .removeClass("d-block")
            .addClass("d-none");
        setTimeout(function () {
            $("#product-search-modal input").focus();
        }, 500);
    });

    $("#product-search-modal input").on("keypress", function (e) {
        if (e.key === "Enter") {
            e.preventDefault();
            $("#product-search-modal #productSearchBtn").click();
        }
    });

    if ($("#consentModal") && $("#consentDetailsModal")) {
        const m = new bootstrap.Modal($("#consentModal"));
        const dm = new bootstrap.Modal($("#consentDetailsModal"));

        $("#consentAcceptAll").on("click", () => {
            $.TemplateMaster.Consent(
                window.requestedConsent,
                true,
                true,
                true,
                true,
            );
            window.location.reload();
        });
        $("#consentRejectAll").on("click", () => {
            $.TemplateMaster.Consent(
                window.requestedConsent,
                false,
                false,
                false,
                false,
            );
            window.location.reload();
        });
        $("#consentDetails").on("click", () => {
            m.hide();
            dm.show();
            const consent = $.TemplateMaster.GetConsent(
                window.requestedConsent,
            );
            $("#functionalConsent").prop("checked", consent.functional);
            $("#performanceConsent").prop("checked", consent.performance);
            $("#targetingConsent").prop("checked", consent.targeting);
        });

        $("#consentSaveSettings").on("click", () => {
            const functional = $("#functionalConsent").is(":checked");
            const performance = $("#performanceConsent").is(":checked");
            const targeting = $("#targetingConsent").is(":checked");

            $.TemplateMaster.Consent(
                window.requestedConsent,
                true,
                functional,
                performance,
                targeting,
            );
            window.location.reload();
        });

        if (window.requestConsent === true) m.show();
    }
});
